<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  name: 'App',
  data() {
    return {
      isRefresh: true
    }
  },
  created() {
  },
  methods: {

  }
}
</script>
<style lang="less">
* {
  padding: 0;
  margin: 0;
}

li {
  list-style: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue